import React, { useEffect } from 'react'
import styled from 'styled-components'
import CardDadosPessoais from './components/CardDadosPessoais'
import CardSenha from './components/CardSenha'
import ConteudoWrapper from '../../components/ConteudoWrapper/ConteudoWrapper'
import { useAssociado } from '../../contexts/AssociadoContext'

const WrapperPerfil = styled.section`
  h1 {
    margin: 30px 0;
  }
`

const Perfil = () => {
  const { dadosAssociado, fetchDadosAssociado } = useAssociado()

  useEffect( () => {
    fetchDadosAssociado()
  }, [] )

  return (
    <WrapperPerfil>
      <h1>Perfil</h1>
      <ConteudoWrapper>
        <CardDadosPessoais
          dadosAssociado={ dadosAssociado }
        />
        <CardSenha />
      </ConteudoWrapper>
    </WrapperPerfil>
  )
}

export default Perfil
